import React__default from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  /** Visible text of the switch */
  children: PropTypes.string.isRequired,
  /** Must be a valid unique ID for accessibility */
  id: PropTypes.string.isRequired,
  /** Change handler callback */
  onChange: PropTypes.func.isRequired,
  /** Determines state of the switch */
  isChecked: PropTypes.bool
};
function Switch(_ref) {
  var children = _ref.children,
    id = _ref.id,
    isChecked = _ref.isChecked,
    onChange = _ref.onChange;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "switcher",
    "data-testid": "switch"
  }, /*#__PURE__*/React__default.createElement("input", {
    checked: isChecked,
    id: id,
    onChange: onChange,
    role: "switch",
    type: "checkbox"
  }), /*#__PURE__*/React__default.createElement("label", {
    "data-testid": "switch-label",
    htmlFor: id
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "switcher-text"
  }, children), /*#__PURE__*/React__default.createElement("span", {
    className: "switcher-control",
    "data-testid": "switch-control"
  }, /*#__PURE__*/React__default.createElement("span", {
    "aria-hidden": "true",
    className: "switcher-circle",
    "data-testid": "switch-circle"
  }))));
}
Switch.propTypes = propTypes;

export { Switch as default };
//# sourceMappingURL=Switch.js.map
